import { combineReducers } from 'redux';

import sidebar from './sidebar';
import alert from './alert';
import auth from './auth';
import agenda from './agenda';
import audio from './audio';



export default combineReducers ({
    sidebar,
    alert,
    auth,
    agenda,
    audio
});